/**
 * フォロー時に解除した際、リストから自分のアイコンを削除
 * @param {String} userId 対象のユーザーID
 */
export const deleteExistingIcon = (userId) => {
  const $iconsNodes = document.querySelectorAll('.supporterImg');
  const $icons = Array.prototype.slice.call($iconsNodes, 0);

  if ($icons) {
    $icons.forEach(el => {
      if (Number(el.getAttribute('data-uid')) === userId) {
        el.parentNode.removeChild(el);
      }
    });
  }
};
